var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_9272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70696 5.70711C6.09748 5.31658 6.73065 5.31658 7.12117 5.70711L18.4349 17.0208C18.8254 17.4113 18.8254 18.0445 18.4349 18.435C18.0444 18.8256 17.4112 18.8256 17.0207 18.435L5.70696 7.12132C5.31643 6.7308 5.31643 6.09763 5.70696 5.70711Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12117 15.4073C8.73064 15.0168 8.73065 14.3836 9.12117 13.9931L16.1922 6.92202C16.5828 6.5315 17.2159 6.5315 17.6065 6.92202C17.997 7.31255 17.997 7.94571 17.6065 8.33623L10.5354 15.4073C10.1449 15.7978 9.51169 15.7978 9.12117 15.4073Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12117 18.4356C5.73064 18.0451 5.73065 17.4119 6.12117 17.0214L17.4349 5.7077C17.8254 5.31718 18.4586 5.31718 18.8491 5.7077C19.2396 6.09822 19.2396 6.73139 18.8491 7.12191L7.53538 18.4356C7.14486 18.8261 6.51169 18.8261 6.12117 18.4356Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_9272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close_menu.a63b54c6b08a3024ac894c416e9a1cd0.svg";
export { ForwardRef as ReactComponent };